"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMessageDialogButtonType = void 0;
var EMessageDialogButtonType;
(function (EMessageDialogButtonType) {
    EMessageDialogButtonType["OK"] = "ok";
    EMessageDialogButtonType["CANCEL"] = "cancel";
})(EMessageDialogButtonType || (exports.EMessageDialogButtonType = EMessageDialogButtonType = {}));
